'use strict';

/**
 * Checks, if the passed string is blank
 * If the passed argument isn't of type string, casts it to string
 * @param string
 */
export function isBlank(string) {
    if (!isString(string)) {
        if (isUndefined(string) || isNull(string)) {
            return true;
        } else if (isNumeric(string)) {
            string = numericToString(string);
        } else {
            // all other types we can use toString for
            string = string.toString();
        }
    }
    return string.length === 0;

}


export function isNull(o) {
    return o === null;
}

export function isUndefined(o) {
    return typeof o === 'undefined';
}

export function isString(o) {
    return typeof o === 'string';
}

export function isBoolean(o) {
    return typeof o === 'boolean';
}

export function isNumeric(o) {
    return typeof o === 'number' || typeof o === 'bigint';
}

export function isNumber(o) {
    return typeof o === 'number';
}

export function isBigInt(o) {
    return typeof o === 'bigint';
}

export function isSymbol(o) {
    return typeof o === 'symbol';
}

export function isFunction(o) {
    return typeof o === 'function';
}

export function isObject(o) {
    return typeof o === 'object';
}

export function isArray(o) {
    return Array.isArray(o);
}

export function numericToString(o) {
    if (isNumber(o)) {
        return Number(o).toString();
    } else if (isBigInt(o)) {
        return BigInt(o).toString();
    } else {
        return '';
    }
}

export function isEmpty(o) {
    return isNull(o) || isUndefined(o) || (isArray(o) && o.length === 0);
}

export function isNotEmpty(o) {
    return !isEmpty(o);
}